import { CompactUser } from 'src/context/user';
import { HAS_SEEN_CALENDAR_REMINDER_STORAGE_KEY } from 'src/constants/storageKeys.const';
import {
  addToLocalStorageArrayEntry,
  hasInLocalStorageArrayEntry,
} from 'src/utils/webStorageArrayUtils';

export const doesNotHaveSeenCalendarReminder = (user: CompactUser | null): boolean => {
  if (!user) return false;

  return !hasInLocalStorageArrayEntry(HAS_SEEN_CALENDAR_REMINDER_STORAGE_KEY, String(user.id));
};

export const addToCalendarReminderStorageEntry = (user: CompactUser | null): void => {
  if (!user) return;

  addToLocalStorageArrayEntry(HAS_SEEN_CALENDAR_REMINDER_STORAGE_KEY, String(user.id));
};
